import {Possessed} from "../Possessed";
import {PossessedGameAssets} from "../PossessedGameAssets";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {gsap} from "gsap"
import {
    PossessedSymbol,
    PossessedSymbolStates,
    PossessedSymbolCreateArgs
} from "./PossessedSymbol";



export class PossessedScatterSymbol extends PossessedSymbol {
    
    private bookAnimation:PIXI.spine.Spine;
    private glowAnimation:PIXI.spine.Spine;
    private bgAnimation:PIXI.spine.Spine;

    private scatterWinAnimation:PIXI.spine.Spine;

    private currentAnimationLevel:number = 0;
    private currentSoundLevel:number = 0;

    private animationTL:gsap.core.Timeline|undefined;

    constructor(args:PossessedSymbolCreateArgs) {
        super(args);

        // Init book and background animations
        this.scatterWinAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.SCATTER_ANIMATION));
        this.scatterWinAnimation.visible = false;

        this.bookAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.SCATTER_ANIMATION));
        this.bookAnimation.state.setAnimation(0, "s1Landing", false);
        
        this.glowAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.SCATTER_ANIMATION));
        this.glowAnimation.visible = false;

        this.bgAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.SCATTER_ANIMATION));
        this.bgAnimation.state.setAnimation(0, "scBg", true);

        this.spriteView.addChild(this.bgAnimation);
        this.spriteView.addChild(this.glowAnimation);
        this.spriteView.addChild(this.bookAnimation);
        this.spriteView.addChild(this.scatterWinAnimation);
    }

    //! Has no proper spin texture that matches the animations
    public override crossFadeFromSpin(fadeDur?: number): gsap.core.Timeline {
        return gsap.timeline();
    }
    public override crossFadeToSpin(fadeDur?: number): gsap.core.Timeline {
        return gsap.timeline();
    }

    public playNoWin(): gsap.core.Timeline {
        const tl = super.playNoWin();
        if(this.currentAnimationLevel > 1) {
            tl.add(() => {
                if(this.animationTL) {
                    this.animationTL.kill();
                }
                this.bookAnimation.state.setAnimation(1, "sStatic", true);
                this.bookAnimation.state.setEmptyAnimation(0, 0);
                this.glowAnimation.state.setEmptyAnimation(0, 0);
            }, '<')
        }
        return tl;
    }
    public setNormal(): gsap.core.Timeline {
        const tl = super.setNormal();
        if(this.currentAnimationLevel > 1) {
            tl.add(() => {
                this.currentAnimationLevel = 2;
                this.updateScatterAnimation(Possessed.reelView.getAllVisibleSymbols().filter(s => s.name == "S").length);
            })
        }
        return tl;
    }


    public moveToScatterLayer() {
        //Possessed.reelView.scatterSymbolsView.addSymbol(this);
    }
    public moveToReelLayer() {
        Possessed.reelView.reelModels[this.reelID].addChild(this);
    }

    public updateScatterAnimation(scatterCount:number) {
        const prevAnimationLevel = this.currentAnimationLevel;
        const clampedCount = Math.min(Math.max(scatterCount, 1), 3);
        this.currentSoundLevel = scatterCount+1;
        if(this.currentAnimationLevel == clampedCount) return;
        
        if(this.animationTL) {
            this.animationTL.progress(1);
        }
        this.animationTL = gsap.timeline();

        if(clampedCount == 1) {
            this.animationTL.add(SpineGSAPWrapper.createTimeline(this.bookAnimation, 0, "s1Landing"));
        } else if(clampedCount == 2) {
            this.animationTL.add(() => {
                SpineGSAPWrapper.resetSpineState(this.glowAnimation);
            })
            this.animationTL.add(() => {this.glowAnimation.state.setAnimation(0, "scGlow", true)});
            this.animationTL.add(SpineGSAPWrapper.createTimeline(this.bookAnimation, 0, "s2Trigger"));
            this.animationTL.add(() => {this.bookAnimation.state.setAnimation(1, "s2Loop", true)});
        } else if(clampedCount == 3) {
            if(prevAnimationLevel == 0) {
                this.animationTL.add(SpineGSAPWrapper.createTimeline(this.bookAnimation, 0, "s2Trigger"));
            }
            this.animationTL.add(() => {
                this.bookAnimation.state.setAnimation(1, "s3Loop", true);
            }, "<")
        }

        this.currentAnimationLevel = clampedCount;
    }

    public override resetState() {
        this.overlay.alpha = 0;
        if(this.currentAnimationLevel > 1) {
            if(this.animationTL) {
                this.animationTL.kill();
                this.animationTL = gsap.timeline()
                    .add(() => {
                        this.glowAnimation.visible = false;
                        this.bookAnimation.state.setAnimation(0, "s1Landing", false);
                        this.bookAnimation.state.setEmptyAnimation(1, 0);
                    });
                this.currentAnimationLevel = 1;
            }
        }

        if(this.reelID > 0 && this.reelID < 4) {
            this.moveToReelLayer();
        }
    }

    public playFsTrigger():gsap.core.Timeline {
        return gsap.timeline()
            .add(()=>{
                SpineGSAPWrapper.resetSpineState(this.glowAnimation);
                SpineGSAPWrapper.resetSpineState(this.scatterWinAnimation);
                this.glowAnimation.state.setAnimation(0, "scGlow", true);
                this.scatterWinAnimation.state.setAnimation(0, "scatterWin", false);
            })
    }

    public playAdditionalSpinTrigger():gsap.core.Timeline {
        return gsap.timeline()
            .add(Possessed.reelView.playExtraSpinPopup(this.reelID, this.reelPosition))
    }
}